import { IconDefinition } from '../../types';

const ThumbUp: IconDefinition = {
  name: 'thumb-up',
  definition: {
    viewBox: '0 0 40 40',
    pathData:
      'M37.4,21.8l-2.8,11.1c-0.4,1.5-1.8,4.2-4.9,4.2H14.9c-1.3,0-2.3-1-2.8-1.8c-0.8,0.8-2.1,1.8-3.6,1.8H3.9 c-0.4,0-0.8-0.4-0.8-0.8V14.2c0-0.2,0.1-0.4,0.2-0.6c0.1-0.1,0.4-0.2,0.6-0.2c0,0,3,0,4.4,0c0,0,0,0,0,0c1,0,2.6,0.9,3.6,1.4 l0.5-0.9c0.2-0.3,4.1-6.9,5.1-8.2c0.1-0.2,0.3-0.4,0.5-0.7c1-1.4,2.3-3.4,4.1-3.5c0,0,0,0,0.1,0c2.1,0,2.8,3.2,3,4.4 c0.2,2,0.2,3.9-1.8,7.3h9.2c0,0,0,0,0,0c0.1,0,2.6,0,4.1,2C37.8,16.9,38.1,19.1,37.4,21.8z'
  }
};

export default ThumbUp;
